import React, { useState, useRef, useEffect, CSSProperties } from 'react'
import styles from './TooltipWrapper.module.scss'
import classNames from 'classnames'
import { TooltipWrapperProps, TooltipPosition } from './types'

const TooltipWrapper: React.FunctionComponent<TooltipWrapperProps> = ({
  dataBdd, children, tooltipText, position, showTooltipOnClick, tooltipStyles, accountForScrollbar,
  hidePointer = false, tooltipChildStyles = ''
}) => {
  const [isHidden, setIsHidden] = useState(true)
  const [offScreenStyle, setOffScreenStyle] = useState<CSSProperties>()
  const [offScreenPointerStyle, setOffScreenPointerStyle] = useState<CSSProperties>()
  const tooltipRef = useRef(document.createElement('span'))

  const toggleTooltip = () => setIsHidden(!isHidden)
  const bdd = !dataBdd ? '' : `${dataBdd}-`
  const windowWidth = window.innerWidth

  useEffect(() => {
    if (!isHidden) {
      const tooltipElement = tooltipRef.current.getBoundingClientRect()

      // Check if tooltip is overflowing on the right side of window
      if (tooltipElement.right > windowWidth) {
        setOffScreenStyle({
          transform: `translateX(calc(-50% - ${tooltipElement.right - windowWidth + 5 + (accountForScrollbar ? + 25 : 0)}px))`
        })
        setOffScreenPointerStyle({
          marginLeft: `calc(${tooltipElement.right - windowWidth + 5 + (accountForScrollbar ? + 25 : 0)}px - 6px)`,
          left: '50%'
        })
      }

      // Check if tooltip is offscreen on the left side
      if (tooltipElement.left < 0 && position) {
        setOffScreenStyle({marginLeft: `${(tooltipElement.left * -1) + 5}px`})
        setOffScreenPointerStyle({left: `calc(50% + ${tooltipElement.left}px)`})
      }
    }
  }, [isHidden, accountForScrollbar, position, windowWidth])

  return (
    <div
      className={classNames(styles['tooltip'], tooltipStyles)}
      data-bdd={`${bdd}tooltip-container`}
      onMouseEnter={!showTooltipOnClick ? () => setIsHidden(false) : undefined}
      onMouseLeave={!showTooltipOnClick ? () => setIsHidden(true) : undefined}
      onClick={showTooltipOnClick ? toggleTooltip : undefined}
    >
      <div className={styles['tooltip__wrap']}>
        {children}
        {
          !isHidden &&
          <span
            data-bdd={`${bdd}tooltip-child`}
            className={classNames(styles['tooltip__inner'], styles[`tooltip__${position ? position : TooltipPosition.TOP}`], tooltipChildStyles)}
            ref={tooltipRef}
            hidden={isHidden}
            style={offScreenStyle}
          >
            {!hidePointer && <span
              className={styles['tooltip__pointer']}
              style={offScreenPointerStyle}
            ></span>}
            {tooltipText}
          </span>
        }
      </div>
    </div>
  )
}

export default TooltipWrapper